import { createContext, useContext, useEffect, useState } from "react";
import {getHost} from "../utils/utils";

// Default context value
const AuthContext = createContext({
    isAuthenticated: false,
    authChecked: false,
    logout: () => {}
});

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authChecked, setAuthChecked] = useState(false);

    // Helper to verify token with backend
    const checkAuth = async () => {
        const token = localStorage.getItem("jwt");
        if (!token) {
            setIsAuthenticated(false);
            setAuthChecked(true);
            return;
        }
        try {
            const res = await fetch(`${getHost()}/api/me`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (res.status === 200) {
                setIsAuthenticated(true);
            } else {
                localStorage.removeItem("jwt");
                setIsAuthenticated(false);
            }
        } catch {
            setIsAuthenticated(false);
        }
        setAuthChecked(true);
    };

    useEffect(() => {
        checkAuth(); // Initial check at mount
        const interval = setInterval(checkAuth, 5 * 60 * 1000); // Every 5 min
        return () => clearInterval(interval);
    }, []);

    // Simple logout
    const logout = () => {
        localStorage.removeItem("jwt");
        setIsAuthenticated(false);
        setAuthChecked(true);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, authChecked, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

// Usage: Call in your components/hooks
export function useAuth() {
    return useContext(AuthContext);
}